import { doc, DocumentReference } from 'firebase/firestore';
import isEmpty from 'lodash/isEmpty';
import { docData } from 'rxfire/firestore';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IUser } from '../../types';
import { authenticatedUserProvider } from '../userProvider';

export type ValidExportDateFormat = 'MM/DD/YYYY' | 'DD/MM/YYYY';

interface IExportDateFormatEntity {
  value: ValidExportDateFormat;
}

/**
 * @description hot observable of the users export date format setting `/userProfiles/${user.id}/settings/exportDateFormat`
 */
export const exportDateFormatSettingProvider =
  new BehaviorSubject<ValidExportDateFormat>('MM/DD/YYYY');

/**
 * @description start observing export date format setting
 */
authenticatedUserProvider()
  .pipe(
    switchMap((user: IUser): Observable<ValidExportDateFormat> => {
      return docData(
        doc(
          user.services.firestore,
          `userProfiles/${user.id}/settings/exportDateFormat`
        ) as DocumentReference<IExportDateFormatEntity>
      ).pipe(
        map((setting: IExportDateFormatEntity): ValidExportDateFormat => {
          if (!isEmpty(setting)) return setting.value;
          return 'MM/DD/YYYY';
        })
      );
    })
  )
  .subscribe(exportDateFormatSettingProvider);
